import React, { useCallback, useEffect, useState } from 'react';
import { LoginButton } from '@telegram-auth/react';
import axios from 'axios';
import useSettings from '../hooks/useSettings';
import { Avatar, Box, ButtonBase, Modal, Stack, Typography } from '@mui/material';
import { CustomBox } from './homepage/PreSale';
import Iconify from '../components/Iconify';

function TelegramLoginButton({ botName }) {
  const { settings, saveSettings } = useSettings()
  const handleLogin = useCallback(async (data) => {
    const API = process.env.REACT_APP_IS_DEV === 'true' ? 'http://localhost:2000/api' : `${process.env.REACT_APP_URL}/api`;
    let url = API + '/auth/login-via-oauth';
    const token = await axios.post(url, { ...data, refCode: settings.refCode })
    saveSettings({ ...settings, token: token.data.token, telegramProfile: data })
  }, [settings])

  const handleLogout = () => {
    saveSettings({ ...settings, telegramProfile: null, token: null })
    setOpen(false)
  }

  const [open, setOpen] = useState(false)

  const { telegramProfile } = settings

  return <Box sx={{
    position: 'relative',
    width: 165,
    overflow: 'hidden',
    height: 45,
    [`& #telegram-login-${botName}`]: {
      opacity: 0,
      height: '100%',
      width: "100%",
      position: 'relative',
      zIndex: 1
    }
  }}>
    {
      !telegramProfile ? <LoginButton
        botUsername={botName}
        onAuthCallback={(data) => {
          handleLogin(data);
        }}
      /> : ''
    }
    {
      telegramProfile ? <>
        <ButtonBase onClick={() => setOpen(true)} sx={{ position: 'absolute', top: 0, left: 0, height: 45, width: 165, zIndex: 0, background: 'url("/images/button-1.png") no-repeat 50% 50%', backgroundSize: 'contain' }}>
          <Typography fontSize={'0.9rem'}>{telegramProfile?.first_name} {telegramProfile?.last_name}</Typography>
        </ButtonBase>
        <Modal open={open} sx={{ alignItems: 'center', justifyContent: 'center', height: '100vh', display: 'flex' }}>
          <Box sx={{ border: 'none !important' }}>
            <CustomBox background='#000' sx={{ borderRadius: ['1.5rem', '1.25rem'] }}>
              <Stack p={2} spacing={2} alignItems={'center'} sx={{ position: 'relative' }}>
                <ButtonBase onClick={() => setOpen(false)} sx={{ position: 'absolute', top: '10px', right: '10px' }}>
                  <Iconify icon={'iconamoon:close-fill'} size={40} />
                </ButtonBase>
                <Typography>Telegram Account</Typography>
                <Iconify icon={'logos:telegram'} size={50} />
                <Typography >{telegramProfile?.first_name} {telegramProfile?.last_name}</Typography>
                <ButtonBase onClick={() => handleLogout()} sx={{ height: 45, width: 165, zIndex: 0, background: 'url("/images/button-1.png") no-repeat 50% 50%', backgroundSize: 'contain' }}>
                  <Typography fontSize={'0.9rem'}>LOGOUT</Typography>
                </ButtonBase>
              </Stack>
            </CustomBox>
          </Box>
        </Modal>
      </> : <ButtonBase sx={{ position: 'absolute', top: 0, left: 0, height: 45, width: 165, zIndex: 0, background: 'url("/images/button-1.png") no-repeat 50% 50%', backgroundSize: 'contain' }}>
        <Typography fontSize={'0.9rem'}>CONNECT TELEGRAM</Typography>
      </ButtonBase>
    }
  </Box>

}

export default TelegramLoginButton;